export const REFUND_TYPE = {
  BANK_PRODUCT: 1,
  PAY_UP_FRONT: 2,
};

const _REFUND_TYPE_DESCRIPTION_MAP = {};
_REFUND_TYPE_DESCRIPTION_MAP[REFUND_TYPE.BANK_PRODUCT] = 'Bank Product';
_REFUND_TYPE_DESCRIPTION_MAP[REFUND_TYPE.PAY_UP_FRONT] = 'Pay Up Front';

export const REFUND_TYPE_DESCRIPTION_MAP = _REFUND_TYPE_DESCRIPTION_MAP;

export default {
  REFUND_TYPE,
  REFUND_TYPE_DESCRIPTION_MAP,
};
